export default __webpack_public_path__ + "static/media/islam_gold.33e5bdc1.svg";